/* Desktop Sticky*/
window.addEventListener('load', (event) => {
  $(window).on('scroll',function(){
    if (window.innerWidth > 989) {
      var scrollTop = $(window).scrollTop(),
      headerOffset = $('.header-wrapper')[0].offsetHeight,
      topOffset = headerOffset + 25,
      bottomOfShare = $('.article-share__desktop').offset().top - topOffset,
      sideHeight = $('.article-share__desktop').outerHeight(),
      shareHeight = $('.article-icons__desktop').outerHeight(),
      bottomOffset = (bottomOfShare + sideHeight) - shareHeight - 55;

      if (scrollTop > bottomOfShare) {
        $('.article-icons__desktop').removeClass('stuck-top');
        $('.article-icons__desktop').removeClass('stuck-bottom');
        $('.article-icons__desktop').addClass('scrolling');
      } else {
        $('.article-icons__desktop').removeClass('scrolling');
        $('.article-icons__desktop').addClass('stuck-top');

      }
      if (scrollTop > bottomOffset) {
        $('.article-icons__desktop').removeClass('scrolling');
        $('.article-icons__desktop').addClass('stuck-bottom');
      }
    }
  });

  /* Mobile Sticky */
  const el = document.querySelector(".article-share__mobile");
  const observer = new IntersectionObserver(
    ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
    { threshold: [1] }
  );
  observer.observe(el);

  /* Generic/Native share */
  var shareButtonMobile = document.querySelector('.share-button__mobile');
  var shareButtonDesktop = document.querySelector('.share-button__desktop');
  var title = document.title;
  var url = document.querySelector('link[rel=canonical]') ? document.querySelector('link[rel=canonical]').href : document.location.href;

  //Mobile
  shareButtonMobile.addEventListener('click', function() {
  if(navigator.share) { // Native web share
      navigator.share({
        title: title,
        url: url
      }).catch(console.error);
    } else { // Fallback
      navigator.clipboard.writeText(url);
      shareButtonMobile.classList.add('copied');
      setTimeout(function(){
        shareButtonMobile.classList.remove('copied');
      },3000);
    }
  });

  //Desktop
  shareButtonDesktop.addEventListener('click', function() {
  if(navigator.share) { // Native web share
      navigator.share({
        title: title,
        url: url
      }).catch(console.error);
    } else { // Fallback
      navigator.clipboard.writeText(url);
      shareButtonDesktop.classList.add('copied');
      setTimeout(function(){
        shareButtonDesktop.classList.remove('copied');
      },3000);
    }
  });


  /* Related Articles */
  if($('.article-related').length){
    var relatedURL = $('.article-related').attr('data-category-url') + '?view=sidebar-links';
    var currentArticle = $('.article-related').attr('data-current-article');
    $(window).on('load',function(){
      $.get(relatedURL,function(html){
        $('.article-related').append(html);
        $('.article-related__item[data-article-id="' + currentArticle + '"]').remove();

        if ($('.article-related').children().length > 0) {
          $('.article-menu__related-title').removeClass('visually-hidden');
        }
      });
    });
  }
})